// Travel Mode — local-only display preference + favourites/recents (UI prefs, NOT a progress system).
import { useEffect, useState } from "react";

const MODE_KEY = "mwq_travel_mode_v1";
const FAV_KEY = "mwq_travel_favs_v1";
const RECENT_KEY = "mwq_travel_recent_v1";
const EVT = "mwq:travel-mode";

const read = (k, fb) => { try { const v = localStorage.getItem(k); return v == null ? fb : JSON.parse(v); } catch { return fb; } };
const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* storage full/blocked: preference simply won't persist */ } };

export function isTravelMode() { return read(MODE_KEY, false) === true; }
export function setTravelMode(on) { write(MODE_KEY, !!on); try { window.dispatchEvent(new Event(EVT)); } catch { /* ignore */ } }

export function useTravelMode() {
  const [on, setOn] = useState(isTravelMode);
  useEffect(() => {
    const h = () => setOn(isTravelMode());
    window.addEventListener(EVT, h); window.addEventListener("storage", h);
    return () => { window.removeEventListener(EVT, h); window.removeEventListener("storage", h); };
  }, []);
  return on;
}

export function getFavourites() { const v = read(FAV_KEY, []); return Array.isArray(v) ? v : []; }
export function toggleFavourite(id) {
  const f = getFavourites(); const next = f.includes(id) ? f.filter((x) => x !== id) : [...f, id];
  write(FAV_KEY, next); try { window.dispatchEvent(new Event(EVT)); } catch { /* ignore */ } return next;
}
export function getRecent() { const v = read(RECENT_KEY, []); return Array.isArray(v) ? v : []; }
export function pushRecent(id) {
  const next = [id, ...getRecent().filter((x) => x !== id)].slice(0, 8);
  write(RECENT_KEY, next); try { window.dispatchEvent(new Event(EVT)); } catch { /* ignore */ }
}

export function useOnline() {
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine !== false));
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return online;
}
